<template>
	<div class="ColorPicker-container" >
		<div class="open-DColorPicker" @click="openClick" :style="{'background-color': bgc}">
			<input type="hidden" :name="input_name" :value="bgc">
			<span class="close-icon" v-if="open">
				<i class="fas fa-times-circle icon"></i>
			</span>
		</div>
		<chrome-picker :value="colors" v-show="open" @input="updateValue"></chrome-picker>
		<button class="button is-warning has-text-weight-bold has-text-white height-42 delete-btn" @click.prevent="remove(this)">{{ t('delete') }}</button>
	</div>
</template>
<script>
    import trans from '../../SiteComponents/translation/categories';
	import swatch from 'vue-color/src/components/Swatches.vue'
	import ClickOutside from 'vue-click-outside'
	export default {
		name:"color-picker-multi",
		props:{
			input_name:{
				type : String,
				default:"color",
			},
			color:{
				type : String,
				default:"#194d33e6",
			},
            locale : {
                type : String,
                default:"ar",
            }
		},
        locales: trans,
		components:{
			'chrome-picker': swatch,
		},
		data () {
			return {
				colors: {hex: this.color},
				open: false,

			}
		},
		computed: {
			bgc () {
				return this.colors.hex
			},
			count(){
				console.log(document.querySelectorAll('ColorPicker-container').length)

			}
		},
		mounted () {
            this.$translate.setLang(this.locale);
			this.popupItem = this.$el
		},
		methods: {
			openClick () {
				this.open = !this.open;
			},
			closeClick(){
				this.open = false
			},
			updateValue (value) {
				this.colors = value
			},
			remove(value){
				this.$el.remove();
			}
		},
		directives: {
			ClickOutside
		}
	}
</script>
<style>
.ColorPicker-container {
	position: relative;
}
.open-DColorPicker {
	width: 50px;
	height: 50px;
	border-radius: 100%;
	cursor: pointer;
	position: relative;
}
.vc-chrome , .vc-swatches{
	position: absolute;
	right: 0;
	top: 55px;
	z-index: 9
}
span.close-icon .icon {
	height: 100%;
	width: 100%;
	color: #ffffff85;
}

span.close-icon {
	position: absolute;
	z-index: 1;
	height: 100%;
	width: 100%;
	font-size: 48px;
}
.ColorPicker-container .delete-btn{
	vertical-align: middle;
}

</style>
